import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import './InvestmentKnowledge.css';

const KNOWLEDGE_WIDTH_MAP = {
  none: 5,
  limited: 25,
  good: 60,
  extensive: 100,
};

class InvestmentKnowledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
    this.setLoadClass = this.setLoadClass.bind(this);
  }

  setLoadClass() {
    this.setState({
      loaded: true,
    });
  }

  static getWidth(value) {
    return `${KNOWLEDGE_WIDTH_MAP[value.toLowerCase()]}%`;
  }

  renderRows(data) {
    const { loaded } = this.state;
    return data.map((row, index) => {
      const barWidth = loaded ? InvestmentKnowledge.getWidth(row.value) : 0;
      return (
        <div className="row" key={`${row.name} (${row.value})`}>
          <div className="category">{`${row.name} (${row.value})`}</div>
          <div className="knowledge-level">
            <div className={`bar bar${index}`} style={{ width: barWidth }} />
          </div>
        </div>
      );
    });
  }

  render() {
    const { knowledge } = this.props;
    return (
      <React.Fragment>
        <Waypoint onEnter={this.setLoadClass} />
        <div className="investment-knowledge-chart">
          {this.renderRows(knowledge)}
        </div>
      </React.Fragment>
    );
  }
}

InvestmentKnowledge.propTypes = {
  knowledge: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

InvestmentKnowledge.defaultProps = {
  knowledge: [{ name: '', value: '' }],
};

export default InvestmentKnowledge;
